export function sanitizeStudyCodeInput(value: string): string {
  return value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export function deriveStudyCodeInitials(name: string): string {
  const tokens = name
    .trim()
    .split(/[\s-]+/)
    .filter(Boolean);
  if (tokens.length === 0) {
    return "";
  }
  return tokens
    .map((token) => token.charAt(0))
    .join("")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
}

export function formatDisplayJoinCode(
  studyCode?: string | null,
  joinCode?: string | null,
): string {
  if (!joinCode) {
    return "";
  }
  return studyCode ? `${studyCode}-${joinCode}` : joinCode;
}
